<script>
  import Button from "./button.svelte"
  export let value = ""
  export let mode = ""
  export let size = "xs"
  export let name
  export let list = null

  let tagvalue = ""
  let tagsInput
  let inputWidth
  
  const focusInput = ()=>{
    tagsInput.focus()
  }

  const handleKey = (e)=>{
    if(e.key=="Enter"){
      tags = tags.concat(tagvalue)
      value = tags.join(",")
      tagvalue = ""
    }
    if(e.key=="Backspace" && tagvalue==""){
      value = value.replace(/(^|,)[^,]+$/,"")
    }
  }

  const removeTag = (idx)=>{
    tags = tags.filter((rows,index)=> index!=idx )
    value = tags.join(",")
  }

  $: tags = value && typeof value === 'string' ? value.split(",") : []

</script>

<div class="form-input tags" on:click={focusInput}>
  {#each tags as tag,idx}
    <Button mode={mode} size={size} on:click={(e)=> removeTag(idx)}>{tag} &times;</Button>
  {/each}
  <input name={name} bind:value={tagvalue} class="tags-input" bind:this={tagsInput} on:keydown={handleKey} style={"width:"+(inputWidth+5 + (list ? 10 : 0))+"px"} {list} >
  <div class="fontwidth" bind:offsetWidth={inputWidth}>{tagvalue}</div>
</div>



<style>
  .form-input.tags{
    padding:2px;
    display:flex;
    flex-wrap: wrap;
  }
  .fontwidth,.tags-input{
    font-size:14px;
  }
  .fontwidth{
    white-space: pre-wrap;
    opacity:0.01;
    pointer-events: none;
    position:relative;
  }
  div.form-input :global(.sbtn){
    margin:2px;
  }
  .tags-input{
    margin:0;
    line-height:20px;
    border:0px;
    width:auto;
  }
  .tags-input::-webkit-calendar-picker-indicator {
    display: none;
  }
  .tags-input:focus{
    outline:0px;
  }
  

</style>